function getLinkName(data) {
    let linkName = 'web:meganav';

    if (data.department) {
        linkName += toKebabCase(`:${data.department}`,'-');
    }

    if (data.subdepartment) {
        linkName += toKebabCase(`:${data.subdepartment}`,'-');
    }

    if (data.category) {
        linkName += data.category.indexOf('-') !== -1 ? toKebabCase(`:${data.category.toString()}`,'') : toKebabCase(`:${data.category}`,'-');
    }

    return linkName;
}

function toKebabCase(str,replaceWith) {
    if(str === null || str === '' || str === undefined)
        return '';
    return str.toLowerCase().replace(/\s+/g, replaceWith);
}

module.exports = data => ({
    event: 'BWSmeganavLink',
    eventContext: {
        linkType: 'meganav click',
        linkName: getLinkName(data)
    }
});



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/atmmapper/global-header-analytics-mapper.js
 **/